// 颜色映射
export const REVIEW_STATUS_COLOR_MAP = {
  //智能体通用状态
  checking: "yellow", //审核中
  reject: "red", //拒绝
  down: "grey", //下架
  
  draft: 'blue', //草稿
  up:'green' //已上架
};

// 状态映射
export const REVIEW_STATUS_TEXT_MAP = {
  checking: "审核中",
  reject: "审核拒绝",
  down: "下架",

  draft: '草稿',
  up:'已上架'
};
